module.exports = __webpack_public_path__ + "img/c&m_full_logo_white.de2a5f94.png";